import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import ConfirmationButton from '../../../app/components/ConfirmationButton';
import Button from '../../../common/components/Button/Button';
import { useTranslation } from '../../../common/hooks/useTranslation';

import { ClonePositionButton } from './ClonePositionButton';

interface SalesInvoicePositionsControlsProps {
  handleResetPositions: () => void;
  selected: number[];
  handleMergePositions: (keys: number[]) => void;
  handleClonePosition: (key: number, count?: number) => void;
  handleMergePositionsByProject: (key: number[]) => void;
  handleSave: () => void;
  isMergeDisabled: boolean;
  readOnly?: boolean;
  isLoading: boolean;
}

export const SalesInvoicePositionsControls: React.FC<
  SalesInvoicePositionsControlsProps
> = ({
  handleResetPositions,
  selected,
  handleMergePositions,
  handleClonePosition,
  handleMergePositionsByProject,
  handleSave,
  isMergeDisabled,
  readOnly,
  isLoading,
}) => {
  const { t, tk } = useTranslation('fvsLng');

  return (
    <div className="d-flex justify-content-between">
      <div className="d-flex gap-1">
        {selected.length > 1 && (
          <>
            <OverlayTrigger
              trigger={isMergeDisabled ? ['hover', 'focus'] : []}
              overlay={
                <Tooltip>
                  {t(tk.finance.mergedPositionsSameAccount)}{' '}
                  {t(tk.prLang.sameProject)}.
                </Tooltip>
              }
            >
              <div>
                <ConfirmationButton
                  confirmation={t(tk.finance.askMergePositions)}
                  onOK={() => handleMergePositions(selected)}
                  disabled={isMergeDisabled || readOnly}
                >
                  {t(tk.finance.mergePositions)}
                </ConfirmationButton>
              </div>
            </OverlayTrigger>
          </>
        )}
        <ConfirmationButton
          confirmation={t(tk.prLang.askMergePositionsByProject)}
          onOK={() => handleMergePositionsByProject(selected)}
          disabled={readOnly}
        >
          {selected.length
            ? t(tk.finance.mergeSelectedPositionsBy)
            : t(tk.finance.mergePositionsBy)}{' '}
          {t(tk.prLang.genitiveProject)}
        </ConfirmationButton>
        {selected.length === 1 && (
          <ClonePositionButton
            onClone={count => handleClonePosition(selected[0], count)}
            disabled={readOnly}
          />
        )}
        <ConfirmationButton
          variant="outline-danger"
          onOK={handleResetPositions}
          confirmation={t(tk.finance.askResetPositions)}
          disabled={readOnly}
        >
          {t(tk.finance.resetPositions)}
        </ConfirmationButton>
      </div>
      <Button onClick={handleSave} disabled={readOnly} isLoading={isLoading}>
        {t(tk.finance.saveAndStepForward)}
      </Button>
    </div>
  );
};
